import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { AmenitiesArray } from '../constants';
import FormikCheckbox from '../../../ui/FormikCheckbox';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { updateFormData, setListing, updateListing } from '../actions';
import { populateListingFromFormData } from '../helpers';

const mapStateToProps = state => ({
  listing: state.Listing
});

export const saveListing = (values, pathAfterSave, props) => {
  let { dispatch, history, listing, step } = props;
  if (values.lastCompleted < step) { values.lastCompleted = step; }
  setTimeout(() => {
    dispatch(updateFormData(values));
    let updatedData = populateListingFromFormData(values);
    if (!updatedData._id) { updatedData._id = listing.listingData._id; }
    dispatch(setListing(updatedData));
    dispatch(updateListing()).then(() => {
      history.push(pathAfterSave);
    })
  }, 1000);
}

class ListingFormAmenities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/photos`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/descriptions`;
  }

  saveFormListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    saveListing(values, pathAfterSave, this.props);
  }

  submitAndExit = (values) => {
    this.saveFormListing(values, `/${this.props.parent}/manage-listings`)
  }

  submitAndBack = (values) => {
    this.saveFormListing(values, this.prevPage)
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false)
    this.saveFormListing(values, this.nextPage)
  }

  exit = (values, { setSubmitting }) => {
    let { dispatch, history } = this.props;
    this.setState({ isSubmitting: true });
    let updatedData = populateListingFromFormData(values);

    setTimeout(() => {
      setSubmitting(false)
      dispatch(setListing(updatedData))
      dispatch(updateListing())
      history.push(`/${this.props.parent}/manage-listings`)
    }, 1000)
  }

  buildAmenitiesList() {
    let amenities = AmenitiesArray;
    return (
      amenities.map((a, index) => {
        return (
          <div className="fieldgroup" key={index}>
            <FormikCheckbox
              name="amenities"
              label={a}
              value={a}
            />
          </div>
        )
      })
    )
  }

  render() {
    let initialValues = this.props.listing.formData;

    const submitText = this.props.exit ? 'Save' : 'Next';

    return (
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={initialValues}>
        {({ values }) => (
          <Form>
            <div>
              <h5>Amenities</h5>
              <div>
                Select all of the amenities below that your listing includes.
                If you do not see an amenity in the list, please add a mention
                of the additional amenity in your property description. <br />
                * - Denotes featured amenities.
              </div>
              {this.buildAmenitiesList()}
            </div>
            <div className="button-row row " >
              <div className=" col-4 " >
                <label
                  className="float-left" onClick={() => { this.submitAndBack(values) }}>Back</label>
              </div>
              <div className="col-8">
                <div className="row">
                  <div className="col-md-6 col-12">
                    {
                      this.props.workflow !== "edit" &&
                      <label
                        className="float-right" onClick={() => { this.submitAndExit(values) }}>Save & Finish Later</label>
                    }
                  </div>
                  <div className="col-md-6 col-12">
                    {
                      this.state.isSubmitting ?
                        <button
                          className="btn-primary float-right" disabled={true} onClick={() => { }}>Saving...</button> :
                        <button className="btn-primary float-right" type="submit">
                          {submitText}
                        </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormAmenities));
